<template>
  <div class="flex-1 flex flex-col">
    <PropertyHeader
      :sub-sections="[subSectionTitle]"
    />

    <div class="w-full max-w-4xl mx-auto px-4 pt-6">
      <ContractHeader class="mb-8" />
      <NuxtPage />
    </div>

    <ContentFooter>
            <nuxt-link
              :to="
                route.name?.endsWith('overview')
                  ? `/customers/${route.params.customerId}/${route.params.propertyId}/${route.params.contractId}`
                  : `/customers/${route.params.customerId}/${route.params.propertyId}/${route.params.contractId}/project/overview`
              "
            >
              <GMButton
                class="uppercase tracking-wider"
                icon-before="chevron-left"
                tertiary
              >
                {{
                  route.name?.endsWith('overview')
                    ? t('CONTRACT')
                    : t('PROJECT_OVERVIEW')
                }}
              </GMButton>
            </nuxt-link>
    </ContentFooter>
  </div>
</template>

<script lang="ts">
import ContractHeader from '~/components/Contracts/Partials/ContractHeader.vue'
import {GMButton} from '@gm/components'
import {useHeaderStore} from '~/use/ui/header'
import {useProjectStore} from '~/use/project/store';
import ContentFooter from "~/components/ui/ContentFooter.vue";
import PropertyHeader from "~/components/Property/PropertyHeader.vue";

export default defineComponent({
  components: {
    PropertyHeader,
    ContentFooter,
    GMButton,
    ContractHeader
  },
  setup() {
    const route = useRoute()
    const contractId = route.params.contractId as string
    const customerId = route.params.customerId as string
    const propertyId = route.params.propertyId as string
    const { setHeaderLink } = useHeaderStore()
    const { loadInvoiceReceivers, loadProducts } = useProjectStore()
    const { t } = useTranslation()

    const subSectionTitle = ref(t('PROJECT'))
    const setSubSectionTitle = (section: string) =>
      (subSectionTitle.value = section)
    provide('setSubSectionTitle', setSubSectionTitle)

    onBeforeMount(() => {
      setHeaderLink({
        Url: `/customers/${customerId}/${propertyId}/${contractId}`,
        Label: 'CONTRACT'
      })
      loadInvoiceReceivers()
      loadProducts()
    })

    return {
      route,
      t,
      subSectionTitle
    }
  }
})
</script>
